import React, { useState, useEffect ,useRef} from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { login, verifyOtp, forgotPassword, resetPassword, loadUserFromToken, reSentOtp } from './../../../../services/global_redux/globale_actions/Login.action';
import './Login.css';
import $ from "jquery"
import dashboardImg from '../../../../assets/global_assets/login_imgs/dashboard.PNG';
import Logo from '../../../../assets/global_assets/login_imgs/logo.png';
import Lock from '../../../../assets/global_assets/login_imgs/lock_icon.png';
import Sms from '../../../../assets/global_assets/login_imgs/sms_icon.png';
import lock_open_icon from '../../../../assets/global_assets/login_imgs/lock_open_icon.png';
function Login({ setIsLoggedIn },props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [user_id, setUser_id] = useState('');
    const [user_email, setUser_email] = useState('');
    const [user_password, setUser_password] = useState('');
    const [user_otp, setUser_otp] = useState('');
    const [new_password, setNew_password] = useState('');
    const [error, setError] = useState('');
    const [errorResentOTP, setErrorResentOTP] = useState('');
    const [stage, setStage] = useState('login');
    const [isFormValid, setIsFormValid] = useState(false);
    const [otpCooldown, setOtpCooldown] = useState(false)
    const [cooldownTimeLeft, setCooldownTimeLeft] = useState(0);
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [enableresent, setenableresent] = useState(true);
    const [currentYear, setCurrentYear] = useState("");

    useEffect(() => {
      const year = new Date().getFullYear();
      setCurrentYear(year);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                if (decodedToken.exp > Date.now() / 1000) {
                    dispatch(loadUserFromToken());
                    setIsLoggedIn(true);
                    window.location.href = '/dashboard';
                } else {
                    localStorage.removeItem('token');
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('dashboardAlertShown');
                    sessionStorage.removeItem('selectedClient');
                    navigate('/login');
                }
            } catch (error) {
                localStorage.removeItem('token');
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('dashboardAlertShown');
                sessionStorage.removeItem('selectedClient');
                navigate('/login');
            }
        }
    }, [dispatch, navigate, setIsLoggedIn]);

    useEffect(() => {
        setShowPassword(false);
        switch (stage) {
            case 'login':
                setIsFormValid(user_id !== '' && user_password !== '');
                break;
            case 'user_otp':
                setIsFormValid(user_otp !== '');
                break;
            case 'reset_password_otp':
                setIsFormValid(user_otp !== '');
                break;
            case 'forgotPassword':
                setIsFormValid(user_email !== '');
                break;
            case 'resetPassword':
                setIsFormValid(user_otp !== '' && new_password !== '');
                break;
            default:
                setIsFormValid(false);
        }

    }, [user_id, user_password, user_otp, user_email, new_password, stage]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true)
        if(!user_id && !user_password){
            setError('Please enter valid user mail and password');
            setIsSubmitting(false)
        }
        else if(!user_id){
            setError('Please enter valid user mail');
            setIsSubmitting(false)
        }else if (!user_password){
            setError('Please enter valid user password');
            setIsSubmitting(false)
        }else{
            const userData = { user_id: user_id.trim(), user_password };
            try {
                const response = await dispatch(login(userData));
                if (response.success) {
                    setStage('user_otp');
                    setIsSubmitting(false)
                    setOtpCooldown(true);
                    setCooldownTimeLeft(30);
                    const timer = setInterval(() => {
                        setCooldownTimeLeft(prevTime => {
                            if (prevTime === 0) {
                                setOtpCooldown(false);
                                clearInterval(timer);
                                return 0;
                            }
                            return prevTime - 1;
                        });
                    }, 1000);
    
                    
                } else {
                    setIsSubmitting(false)
                    setError('Please enter valid user mail and password');
                    setStage('login');
                }
            } catch (error) {
                setIsSubmitting(false)
                setError(error.message || 'Please enter valid user mail and password');
                setStage('login');
            }
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if(!user_otp){

            setError('Please enter the valid OTP');
        }else{
            try {
                const response = await dispatch(verifyOtp({ user_id, user_otp }));
                console.log("response",response);
                
                if (response.success) {
                    setIsLoggedIn(true);
                    // navigate('/dashboard');
                    window.location.href = '/dashboard';
                    setError('');
                    setOtpCooldown(true);
                    setCooldownTimeLeft(30);
                    setUser_otp('');
                    const timer = setInterval(() => {
                        setCooldownTimeLeft(prevTime => {
                            if (prevTime === 0) {
                                setOtpCooldown(false);
                                clearInterval(timer);
                                return 0;
                            }
                            return prevTime - 1;
                        });
                    }, 1000);
                } else {
                    
                    setError(response.message);
                }
            } catch (error) {
                setError(error.message || 'Invalid OTP. Try again or generate a new OTP');
            }
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setIsSubmitting(true)
        if(!isFormValid){
            setError('Please enter the valid mail');

        }else{
            try {
                const response = await dispatch(forgotPassword({ user_email: user_email.trim() }));
                if (response.success) {
                    setIsSubmitting(false)
                    setError('');
                    setStage('resetPassword');
                    setOtpCooldown(true);
                    setCooldownTimeLeft(30);
                    setUser_id(user_email);
        
                    const timer = setInterval(() => {
                        setCooldownTimeLeft(prevTime => {
                            if (prevTime === 0) {
                                setOtpCooldown(false);
                                clearInterval(timer);
                                return 0;
                            }
                            return prevTime - 1;
                        });
                    }, 1000);
                } else {
                    setIsSubmitting(false)
                    setStage('forgotPassword');
                    setError(response.message ||'Please enter the valid mail id');
                }
            } catch (error) {
                setIsSubmitting(false)
                setStage('forgotPassword');
                setError(error.message || 'Please enter the valid mail');
            }
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if(!isFormValid){
            setError('Please enter the valid OTP and new password');
        }else{
            try {
                const response = await dispatch(resetPassword({ user_email, user_otp, new_password }));
                console.log("Reset Password Response", response);
                
                if (response.success) {
                    setStage('login');
                    setError('');
                    setOtp(new Array(6).fill(''));  
                    setOtpCooldown(true);
                    setCooldownTimeLeft(30);
                    setUser_otp('');
    
                    const timer = setInterval(() => {
                        setCooldownTimeLeft(prevTime => {
                            if (prevTime === 0) {
                                setOtpCooldown(false);
                                clearInterval(timer);
                                return 0;
                            }
                            return prevTime - 1;
                        });
                    }, 1000);
                } else {
                    
                    setError(response.message ||'Invalid OTP or new password');
                }
            } catch (error) {
                setError(error.message || 'Something went wrong ');
            }

        }
    };


    const handleStageChange = (newStage) => {
        setStage(newStage);
        setError('');
    };
    const resendOtp = async () => {
        $('resentbtn').prop("disabled", true);
        setenableresent(false)
        try {
            const response = await dispatch(reSentOtp({ user_id: user_id }));
            if (response.success === true) {
                setErrorResentOTP('');
                setOtpCooldown(true);
                setCooldownTimeLeft(30);
                setenableresent(true)
                const timer = setInterval(() => {
                    setCooldownTimeLeft(prevTime => {
                        if (prevTime === 0) {
                            setOtpCooldown(false);
                            clearInterval(timer);
                            return 0;
                        }
                        return prevTime - 1;
                    });
                }, 1000);
            } else {
                setenableresent(true)
                const errorData = await response.json();
                setErrorResentOTP(errorData.message || 'Something went wrong ');
            }
        } catch (error) {
            setenableresent(true)
            setErrorResentOTP('Something went wrong ');
        }
    };


    const inputRefs = useRef([]);

const handleChange = (element, index) => {
    setErrorResentOTP('');
    const value = element.value.replace(/[^0-9]/g, '');
    if (!value) return;
  
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  
    const fullOtp = newOtp.join('');
  
    if (!/^\d*$/.test(fullOtp)) {
      setError('Please enter numbers only');
    } else {
      setUser_otp(fullOtp);
      setError('');
    }
    if (index < 5 && value) {
      inputRefs.current[index + 1].focus();
    }
  };
  

const handleBackspace = (e, index) => {
  if (e.key === 'Backspace') {
    if (otp[index]) {
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
    } else if (index > 0) {
      inputRefs.current[index - 1].focus();
    }
  }
};
const handlePaste = (e) => {
    e.preventDefault();
    
    const pastedData = e.clipboardData.getData('Text').replace(/\D/g, '');
  
    if (pastedData.length === 6) {
      const newOtp = pastedData.split('').slice(0, 6);
  
      setOtp(newOtp);  
      setUser_otp(pastedData);
  
      newOtp.forEach((val, i) => {
        if (inputRefs.current[i]) {
          inputRefs.current[i].value = val;
        }
      });
  
      if (inputRefs.current[5]) {
        inputRefs.current[5].focus();
      }
    }
  };
  
    return (
        <div className="container-body loginMainContainer m-0 p-0">
          <div className="col-md-12 m-0 mainpagee">
            <div className="row p-0 m-0 ">
              <div className="col-md-7  p-0 loginDashboardPage">
                <div className="row p-0 m-0 mainrowlogin">
                    <div className="col-md-11  p-0 m-0 loginLeft loginLeftExtra">
                    <div className="imgAnim1"></div>
                <div className="imgAnim2"></div>
                <div className="row loginlftText">
                  <div className="ms-0">
                  <h1 className="text-white m-0 textSize1 PoppinsLogin dashboardcontentpadding">Simplify & Manage</h1>
                  <h4 className="text-white m-0 textSize1 PoppinsLogin dashboardcontentpadding">Compliance In-House</h4>
                  <p className="text-muted1 textSize4 text-light-login1 mt-2">Handle complex compliance processes with ease—<br/> AccunityHR makes it simple, scalable, and self-managed.
                  </p>
                  </div>
                  <div className="loginDashboard col-md-12 ">
                    <img src={dashboardImg} alt="Dashboard" className="loginDashboardImg " />
                  </div>
                </div>
                    </div>
                </div>
              </div>
      
              <div className="col-md-5 p-0 h-100">
                <div className="col-md-12  d-flex align-items-center justify-content-center paddingandmarginLogin">
                <div className="row loginformmailrow">
                    <div className="col-md-11">
                    <div className="row">
                    <div className="loginForm  w-100">
      
                    <div className="row justify-content-center">
                    <div className="col-md-12">
                  <div className=" mb-4 mt-2">
                    <img src={Logo} alt="Logo"  className="loginlogoImg" />
                  </div>
                    <h5 className=" font-weight-bolder1  m-0 p-0 textSize1 PoppinsLogin mt-3">Stay Compliant, Stay Ahead</h5>
                    <p className="text-muted textSize4 text-light-login mt-2 pt-1 mb-3 pb-2">Your trusted partner for efficient and automated compliance processes</p>
                    {stage === 'login' && (
                        <form onSubmit={handleLogin}>
                            <div class="form-group">
                                <label for="usermail" className='textSize3 PoppinsLogin pb-1'><b>User Mail</b></label>
                                <div className="mb-3 position-relative">
                                    <input
                                    type="text"
                                    className="form-control textSizeinputlogin PoppinsLogin textSize4"
                                    placeholder="User Mail"
                                    name="user_id"
                                    value={user_id}
                                    onChange={(e) => setUser_id(e.target.value)}
                                    id="usermail"
                                    disabled={isSubmitting}
                                    />
                                    <img
                                    src={Sms}
                                    alt="user icon"
                                    className="position-absolute "
                                    style={{
                                        right: '15px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        height: '20px',
                                        width: '20px',
                                    }}
                                    />
                                </div>
                            </div>
                        <div class="form-group">
                            <label for="password" className='textSize3 PoppinsLogin pb-1'><b>Password</b></label>
                            <div className="mb-3 position-relative">
                                <input
                                type={showPassword ? "text" : "password"}
                                className="form-control textSizeinputlogin textSize4 PoppinsLogin"
                                placeholder="Password"
                                id="password"
                                name="user_password"
                                value={user_password}
                                onChange={(e) => setUser_password(e.target.value)}
                                disabled={isSubmitting}
                                />
                                <img
                                src={showPassword ? lock_open_icon : Lock}
                                alt="lock icon"
                                className="position-absolute"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '20px',
                                    width: '20px',
                                    cursor: 'pointer'
                                }}
                                />
                            </div>
                        </div>
                            {/* {error && <span className="text-danger textSize4">{error}</span>} */}
                            {error && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {error}
                                </div>
                                </span>}
                            <div className="mb-3">
                            {/* <a href="#" className="text-primary textSize3 PoppinsLogin" onClick={() => handleStageChange('forgotPassword')} disabled ={stage === "login"}>Forgot Password?</a> */}
                            <a
                                href="#"
                                className={`loginforgotpasswordcolor textSize3 PoppinsLoginlight ${stage !== 'login' ? 'disabled-link-login' : ''}`}
                                onClick={(e) => {
                                    if (stage === 'login') {
                                        handleStageChange('forgotPassword');
                                    return;
                                    }
                                }}
                                >
                                Forgot Password?
                            </a>

                        </div>
                        <button type="submit" className="btn loginbtnprimary w-100 py-2 PoppinsLogin" disabled={isSubmitting} ><b className='textSize3' >Get OTP</b></button>
                            
                        </form>
                    )}

                    {stage === 'user_otp' && (
                        <form onSubmit={handleVerifyOtp}>
                            <div class="form-group">
                                <label for="usermail" className='textSize3 PoppinsLogin pb-1'><b>User Mail</b></label>
                                <div className="mb-3 position-relative">
                                    <input
                                    type="text"
                                    className="form-control textSizeinputlogin PoppinsLogin"
                                    placeholder="User Mail"
                                    name="user_id"
                                    value={user_id}
                                    id="usermail"
                                    />
                                    <img
                                    src={Sms}
                                    alt="user icon"
                                    className="position-absolute "
                                    style={{
                                        right: '15px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        height: '20px',
                                        width: '20px',
                                    }}
                                    readOnly
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="otp"  className='textSize3 PoppinsLogin pb-1'><b>OTP</b></label>
                                <div className="mb-3 position-relative">
                                    <div className="d-flex gap-2 position-relative mb-3 otp-container">
                                        {otp.map((digit, index) => (
                                            <input
                                            key={index}
                                            type="text"
                                            className={`form-control text-center textSize4 PoppinsLogin p-3 ${error ? 'otp-error' : ''}`}
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) => handleChange(e.target, index)}
                                            onKeyDown={(e) => handleBackspace(e, index)}
                                            onPaste={(e) => handlePaste(e)} 
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            style={{ width: '53px', height: '50px' }}
                                            disabled={isSubmitting}
                                        />
                                        
                                        ))}
                                    </div>

                                </div>
                            </div>
                            {error && 
                                <span className="text-danger textSize4" style={{ color: 'red' }}>
                                    <div className="error-message">
                                        <i className="bi bi-exclamation-circle-fill me-0"></i>
                                        {error}
                                    </div>
                                </span>
                            }
                            
                            <div className='text-center'>
                            {otpCooldown && (
                                <p style={{ color: 'black', fontSize: '14px', margin: "3px" }} className='textSize4'>Resend OTP in {cooldownTimeLeft} seconds</p>
                            )}
                            {!otpCooldown && (
                                <a className="text-dark btn-sm btn pb-2 text-danger resentbtn textSize4" value={user_id} 
                                // onClick={() => resendOtp({ user_id })} 
                                onClick={(e) => {
                                    if (enableresent === true) {
                                        resendOtp({ user_id })
                                    return;
                                    }
                                }}
                                style={{ margin: '0px' }}>Resend OTP</a>
                            )}
                            {errorResentOTP && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {errorResentOTP}
                                </div>
                                </span>}
                            </div>
                            
                            <a
                                href="#"
                                className={`loginforgotpasswordcolor textSize3 PoppinsLoginlight ${stage !== 'login' ? 'disabled-link-login' : ''}`}
                                onClick={(e) => {
                                    if (stage === 'login') {
                                    e.preventDefault();
                                    return;
                                    }
                                    handleStageChange('forgotPassword');
                                }}
                                >
                                Forgot Password?
                            </a>
                            <div>
                            <button type="submit" className="btn loginbtnprimary w-100 py-2 PoppinsLogin" disabled={isSubmitting}>Log In</button>
                            </div>
                        </form>
                    )}
                    {stage === 'forgotPassword' && (
                        <form onSubmit={handleForgotPassword}>
                            {/* <p>Enter your user email to generate and reset password</p> */}
                            <div class="form-group">
                            <label for="user_email"  className='textSize3 PoppinsLogin pb-1'><b>User Mail</b></label>
                            <div className="mb-3 position-relative">
                                <input
                                type="text"
                                className="form-control textSizeinputlogin PoppinsLogin"
                                placeholder="User Mail"
                                name="user_email" value={user_email} onChange={(e) => setUser_email(e.target.value)}
                                id="user_email"
                                />
                                <img
                                src={Sms}
                                alt="user icon"
                                className="position-absolute "
                                style={{
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '20px',
                                    width: '20px',
                                }}
                                disabled={isSubmitting}
                                />
                            </div>
                        </div>
                            {/* {error && <span className="text-danger textSize4 PoppinsLogin" style={{ color: 'red' }}>{error}</span>} */}
                            {error && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {error}
                                </div>
                                </span>}
                            
                        <button type="submit" className="btn loginbtnprimary w-100 py-2 PoppinsLogin" disabled={isSubmitting}><b className='textSize3' >Get OTP</b></button>
                        <div className="mt-3 text-center textSize4 RalewayLogin">
                            <a href="#" className="text-primary fw-bold"  onClick={() => handleStageChange('login')}>Login ?</a>
                        </div> 
                        </form>
                    )}
                    {stage === 'resetPassword' && (
                        <form onSubmit={handleResetPassword}>
                            <div class="form-group">
                                <label for="usermail"  className='textSize3 PoppinsLogin pb-1'><b>User Mail</b></label>
                                <div className="mb-3 position-relative">
                                    <input
                                    type="text"
                                    className="form-control textSizeinputlogin PoppinsLogin"
                                    placeholder="User Mail"
                                    name="user_id"
                                    value={user_email}
                                    id="usermail"
                                    />
                                    <img
                                    src={Sms}
                                    alt="user icon"
                                    className="position-absolute "
                                    style={{
                                        right: '15px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        height: '20px',
                                        width: '20px',
                                    }}
                                    readOnly
                                    />
                                </div>
                            </div>
                            
                            <div class="form-group">
                                <label for="otp"  className='textSize3 PoppinsLogin pb-1'><b>Enter OTP</b></label>
                                <div className="mb-3 position-relative">
                                    <div className="d-flex gap-2 position-relative mb-3">
                                        {otp.map((digit, index) => (
                                            <input
                                            key={index}
                                            type="text"
                                            className="form-control text-center textSize4 PoppinsLogin"
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) => handleChange(e.target, index)}
                                            onKeyDown={(e) => handleBackspace(e, index)}
                                            onPaste={(e) => handlePaste(e)} 
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            style={{ width: '40px', height: '40px' }}
                                        />
                                        
                                        ))}
                                    </div>
                                </div>
                            </div>
                        <div class="form-group">
                            <label for="Newpassword"  className='textSize3 PoppinsLogin pb-1'><b>Password</b></label>
                            <div className="mb-3 position-relative">
                                <input
                                type={showPassword ? "text" : "password"}
                                className="form-control textSizeinputlogin bg-white textSize4 PoppinsLogin"
                                placeholder="New Password"
                                id="Newpassword"
                                name="new_password"
                                value={new_password}
                                onChange={(e) => setNew_password(e.target.value)}
                                />
                                <img
                                src={showPassword ? lock_open_icon : Lock}
                                alt="lock icon"
                                className="position-absolute"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    height: '20px',
                                    width: '20px',
                                    cursor: 'pointer'
                                }}
                                />
                            </div>
                        </div>
                            {/* {error && <span className="text-danger textSize4" style={{ color: 'red' }}>{error}</span>}  */}
                            {error && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {error}
                                </div>
                                </span>}
                            <div className='text-center'>
                            {otpCooldown && (
                                <p style={{ color: 'black', fontSize: '14px', margin: "3px" }} className='textSize4'>Resend OTP in {cooldownTimeLeft} seconds</p>
                            )}
                            {!otpCooldown && (
                                <a className="text-dark btn-sm btn pb-2 text-danger resentbtn textSize4" value={user_email} 
                                onClick={(e) => {
                                    if (enableresent === true) {
                                        resendOtp({ user_email })
                                    return;
                                    }
                                }}
                                style={{ margin: '0px' }}>Resend OTP</a>
                            )}
                            
                            {errorResentOTP && <span className="text-danger textSize4" style={{ color: 'red' }}>
                                <div className="error-message">
                                    <i className="bi bi-exclamation-circle-fill me-0"></i>
                                    {errorResentOTP}
                                </div>
                                </span>}
                            </div>
                            <button type="submit" className="btn loginbtnprimary w-100 py-2 PoppinsLogin">Reset Password</button>
                        </form>
                    )}

                        {/* <div className="mt-3 text-center textSize4 RalewayLogin text-secondary">
                            <span>Don't have an account? </span>
                            <a href="#" className="text-primary fw-bold">Sign up for free</a>
                        </div> */}
                    </div>
                    </div>

                    
                </div>
                </div>
                    </div>
                </div>
                </div>
                            
                <div className=" plicydivlogin text-center text-muted small d-flex justify-content-between PoppinsLoginlight textSize5" >
                    <span>Privacy Policy</span> <span>Copyright {currentYear}</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      );
      
}

export default Login;
